import PropTypes from 'prop-types';
import styled from 'styled-components';
import { pure } from 'recompose';

const calculateTransform = ({ direction }) => {
  let rotate = -135;

  if (direction === 'up') {
    rotate = 45;
  }

  return `rotate(${rotate}deg)`;
};

const calculateMarginTop = ({ direction }) => {
  let top = -5;

  if (direction === 'up') {
    top = -2;
  }

  return `${top}px`;
};

const getColor = ({ color }) => color;

const Arrow = styled.span`
  position: absolute;
  overflow: hidden;
  display: inline-block;
  font-size: 12px; /*set the size for arrow*/
  width: 6px;
  height: 6px;
  margin-top: ${calculateMarginTop};
  top: 50%;
  border-top: 1px solid ${getColor};
  border-left: 1px solid ${getColor};
  transform: ${calculateTransform};
  right: 20px;

`;

Arrow.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
};

Arrow.defaultProps = {
  direction: 'down',
  color: '#a9bdcd',
};

export default pure(Arrow);



// WEBPACK FOOTER //
// ./src/components/Atoms/Arrow/index.js